import { useState, type FormEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../hooks/useToast';
import { Validator } from '../utils/validation';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{ username?: string; password?: string }>({});
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { showToast } = useToast();

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/direct';

  const validate = (): boolean => {
    const newErrors: { username?: string; password?: string } = {};
    const usernameResult = Validator.validateString(username, {
      required: true,
      minLength: 3,
      maxLength: 50,
    });
    if (!usernameResult.isValid) newErrors.username = usernameResult.errors[0];
    const passwordResult = Validator.validateString(password, {
      required: true,
      minLength: 6,
      maxLength: 100,
    });
    if (!passwordResult.isValid) newErrors.password = passwordResult.errors[0];
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!validate()) {
      showToast('请检查输入信息', 'warning');
      return;
    }
    setLoading(true);
    try {
      await login(username, password);
      showToast('登录成功', 'success');
      setTimeout(() => navigate(from, { replace: true }), 500);
    } catch (error) {
      showToast(error instanceof Error ? error.message : '登录失败，请检查用户名和密码', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div className="glass-card">
            <div className="text-center mb-4">
              <i className="fas fa-microphone-alt" style={{ fontSize: '4rem', color: '#4facfe' }}></i>
              <h2 className="mt-3 mb-2">科学声响</h2>
              <p className="text-muted">学术配音系统</p>
            </div>
            <form onSubmit={handleSubmit} noValidate>
              <div className="mb-3">
                <label htmlFor="username" className="form-label">
                  <i className="fas fa-user me-2"></i>用户名
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="请输入用户名"
                  maxLength={50}
                  autoComplete="username"
                />
                {errors.username && <div className="invalid-feedback">{errors.username}</div>}
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  <i className="fas fa-lock me-2"></i>密码
                </label>
                <input
                  type="password"
                  className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="请输入密码"
                  maxLength={100}
                  autoComplete="current-password"
                />
                {errors.password && <div className="invalid-feedback">{errors.password}</div>}
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin me-2"></i>登录中...
                  </>
                ) : (
                  <>
                    <i className="fas fa-sign-in-alt me-2"></i>登录
                  </>
                )}
              </button>
            </form>
            <div className="text-center mt-4">
              <p className="text-muted">还没有账号？请联系管理员</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}